import { createReducer, on } from '@ngrx/store';
import { getConfPillReminder } from '../actions/set-pill-reminder-config.actions';
import { PillReminderConfig } from '../networking/models/pill-reminder/responses/reminders-res';

export interface StatePillReminderConfig {
    data: PillReminderConfig;
}

export const initialState: StatePillReminderConfig = {
  data: {
    feature_active_web: false,
    feature_active_android: false,
    feature_active_ios: false,
    objectID: 'PILL_REMINDER_CONFIG'
  },
}

const _setPillReminderConfigReducer = createReducer(initialState,
  on(getConfPillReminder, (state, { data }) => ({ ...state, data: {...data} })),
);

export function setPillReminderConfigReducer(state, action) {
  return _setPillReminderConfigReducer(state, action);
}
